import { declareComponent } from '@/registry'
import { LoadingModule } from '../ui/Loading'

export const Journeys = /*#__PURE__*/ declareComponent(
	'journeys',
	'module-journeys',
	() =>
		import(/* webpackChunkName: 'module-journeys' */ './Journeys/Journeys'),
	LoadingModule,
)

export const Roadmap = /*#__PURE__*/ declareComponent(
	'roadmap',
	'module-journeys-roadmap',
	() =>
		import(
			/* webpackChunkName: 'module-journeys-roadmap' */ './Journeys/Roadmap'
		),
	LoadingModule,
)

export const Lines = /*#__PURE__*/ declareComponent(
	'lines',
	'module-lines',
	() => import(/* webpackChunkName: 'module-lines' */ './Lines/Lines'),
	LoadingModule,
)

export const LineSingle = /*#__PURE__*/ declareComponent(
	'line-single',
	'module-lines-line-single',
	() =>
		import(
			/* webpackChunkName: 'module-lines-line-single' */ './Lines/LineSingle'
		),
	LoadingModule,
)

export const LineTimetable = /*#__PURE__*/ declareComponent(
	'line-timetable',
	'module-lines-line-timetable',
	() =>
		import(
			/* webpackChunkName: 'module-lines-line-timetable' */ './Lines/LineTimeTable'
		),
	LoadingModule,
)

export const Around = /*#__PURE__*/ declareComponent(
	'around',
	'module-around',
	() => import(/* webpackChunkName: 'module-around' */ './Around/Around'),
	LoadingModule,
)

export const Stations = /*#__PURE__*/ declareComponent(
	'stations',
	'module-stations',
	() =>
		import(/* webpackChunkName: 'module-stations' */ './Stations/Stations'),
	LoadingModule,
)
